import React from 'react';
import Selection from './Selection';
import { ApplicationView, useController } from '@aha-app/mvc';
import WhiteboardController from '../../controllers/WhiteboardController';
import DrawerPortal from './DrawerPortal';
import Settings from './settings';

export interface DrawerProps {
  paths: string[];
  fullPath: string[];
}

type Components = Record<string, React.FC<DrawerProps>>;

const DrawerComponents: Record<string, React.FC<DrawerProps>> = {
  selection: Selection,
  settings: Settings,
};

export const renderPath = (
  paths: string[],
  fullPath: string[],
  components: Components
) => {
  const Component = components[paths[0]];

  if (Component) {
    return <Component paths={paths.slice(1)} fullPath={fullPath} />;
  } else {
    return (
      <aha-alert type='warning'>
        Invalid path: <code>{JSON.stringify(fullPath)}</code>
      </aha-alert>
    );
  }
};

const Drawer: React.FC = () => {
  const controller = useController(WhiteboardController);
  const { drawerPath } = controller.state;

  if (drawerPath) {
    const paths = drawerPath.replace(/^\/+|\/+$/g, '').split('/');
    const content = renderPath(paths, paths, DrawerComponents);

    return (
      <DrawerPortal drawerOpen={Boolean(drawerPath)}>{content}</DrawerPortal>
    );
  }

  return null;
};

export default ApplicationView(Drawer);
